// RowActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";
const RowCollegeActionsMenu = ({
  row,
  client_id,
  onCollegeEdit,
  onCollegeDelete,
  onCreateUser,
  onViewUsers,
  hasPermission,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isInactive = row.is_college_active == 0;
  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {!hasPermission("edit") && (
          <MenuItem
            onClick={() => {
              onCollegeEdit(row);
              handleClose();
            }}
          >
            Edit College
          </MenuItem>
        )}
        {!hasPermission("delete") && (
          <MenuItem
            disabled={isInactive}
            onClick={() => {
              onCollegeDelete(row.college_id);
              handleClose();
            }}
          >
            Delete College
          </MenuItem>
        )}
        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateUser(client_id, row.college_id, row.society_id, row.db_instance_id);
            handleClose();
          }}
        >
          Create User
        </MenuItem>
        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewUsers(client_id, row.college_id, row.college_name, row.db_instance_id);
            handleClose();
          }}
        >
          View Users
        </MenuItem>
      </Menu>
    </>
  );
};
RowCollegeActionsMenu.propTypes = {
  row: PropTypes.shape({
    client_id: PropTypes.number.isRequired,
    college_id: PropTypes.number.isRequired,
    society_id: PropTypes.number.isRequired,
    college_name: PropTypes.string.isRequired,
    db_instance_id: PropTypes.number.isRequired,
    is_college_active: PropTypes.number.isRequired,
  }).isRequired,
  client_id: PropTypes.number.isRequired,
  onCollegeEdit: PropTypes.func.isRequired,
  onCollegeDelete: PropTypes.func.isRequired,
  onCreateUser: PropTypes.func.isRequired,
  onViewUsers: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
};
export default RowCollegeActionsMenu;
